import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface NavigationState {
  currentPage: string
  isMenuOpen: boolean
  breadcrumbs: Array<{ label: string; path: string }>
}

const initialState: NavigationState = {
  currentPage: 'home',
  isMenuOpen: false,
  breadcrumbs: [{ label: '首页', path: '/' }],
}

const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    setCurrentPage: (state, action: PayloadAction<string>) => {
      state.currentPage = action.payload
    },
    toggleMenu: (state) => {
      state.isMenuOpen = !state.isMenuOpen
    },
    setMenuOpen: (state, action: PayloadAction<boolean>) => {
      state.isMenuOpen = action.payload
    },
    setBreadcrumbs: (state, action: PayloadAction<Array<{ label: string; path: string }>>) => {
      state.breadcrumbs = action.payload
    },
    addBreadcrumb: (state, action: PayloadAction<{ label: string; path: string }>) => {
      state.breadcrumbs.push(action.payload)
    },
    removeBreadcrumb: (state, action: PayloadAction<number>) => {
      state.breadcrumbs.splice(action.payload, 1)
    },
  },
})

export const {
  setCurrentPage,
  toggleMenu,
  setMenuOpen,
  setBreadcrumbs,
  addBreadcrumb,
  removeBreadcrumb,
} = navigationSlice.actions
export default navigationSlice.reducer